import api from '@/api';

export default function useAlfabank() {
  async function createPayment({ priceId, periodId, paymentMethodId }) {
    const result = await api.post('/billing/payment/alfabank/create', {
      priceId, periodId, paymentMethodId,
    });
    return result.data;
  }

  async function upgradePayment({ planId, paymentMethodId }) {
    const result = await api.post('/billing/payment/alfabank/upgrade', {
      planId,
      paymentMethodId,
    });

    return result.data;
  }

  async function createPaymentMethod() {
    const result = await api.post('/billing/payment/alfabank/method/create');

    return result.data;
  }

  async function createPaymentMethodAndStartTrial(planId) {
    const result = await api.post('/billing/payment/alfabank/method/createWithTrial', {planId});

    return result.data;
  }

  async function renewPayment({ priceId, periodId, paymentMethodId }) {
    const result = await api.post('/billing/payment/alfabank/renew', {
      priceId, periodId, paymentMethodId,
    });

    return result.data;
  }

  async function prolongSubscriptionPayment() {
    const result = await api.post('/billing/payment/alfabank/prolong_subscription', null);

    return result.data;
  }

  async function quotaPayment({ itemType, count, paymentMethodId }) {
    const result = await api.post('/billing/payment/alfabank/quota', {
      paymentMethodId, itemType, count,
    });

    return result.data;
  }

  return {
    createPayment,
    upgradePayment,
    createPaymentMethod,
    renewPayment,
    prolongSubscriptionPayment,
    quotaPayment,
    createPaymentMethodAndStartTrial,
  };
}
